<script>
import FormInput from '../forms/FormInput.vue';
import FormPhoneInput from '../forms/FormPhoneInput.vue';
import Button from '../buttons/Button';
import FormModal from '../modals/FormModal.vue';

export default {
    components: {
        FormInput,
        FormPhoneInput,
        Button,
        FormModal
    },
    props: {
        showModal: Boolean,
        modalTitle: String,
        referralDetails: {
            type: Array,
            default: function () {
                return [];
            },
        },
        intakeLinkDetails: {
            type: Array,
            default: function () {
                return [];
            },
        },
        inviteClientRoute: {
            type: String,
            default: function () {
                return null;
            },
        },
        importCsvToInviteRoute: {
            type: String,
            default: function () {
                return null;
            },
        }
    },

    data() {
        let modalTitle = `Invite ${this.modalTitle}`
        let referralId =
                this.referralDetails[0].custom_link == null
                    ? this.referralDetails[0].link
                    : this.referralDetails[0].custom_link
        return {
            actualReferralId: referralId,
            customizeReferralLink: false,
            customizeReferralLinkForm: {
                referral_id: null,
                old_referral_id: null,
            },
            isUpdateReferralCodeLoading: false,
            invitationForm: {
                invitation_email: null,
                invitation_phone: null,
            },
            isButtonLoading: false,
            submitButtonText: 'Submit',
            inviteModalTitle: modalTitle
        }
    },

    methods: {
        copyReferralURL() {
            this.$refs.referral_link.focus();
            document.execCommand("copy");
        },
        
        copyIntakeFormURL() {
            this.$refs.intake_form_link.focus();
            document.execCommand("copy");
        },
        
        handleReferralUpdateSubmit() {
            this.isUpdateReferralCodeLoading = true;
            this.$inertia.post(
                route("save-custom-referral-id"),
                this.customizeReferralLinkForm,
                {
                    onSuccess: (response) => {
                        this.$toastr.s("Referral Code Update Successfully");
                        this.showModal = true;
                        this.isUpdateReferralCodeLoading = false;
                        this.customizeReferralLink = false;
                    },
                    onError: (errors) => {
                        this.isUpdateReferralCodeLoading = false;
                        if (errors.message) {
                            this.$toastr.e(errors.message);
                        }
                    },
                }
            );
        },

        handleInvitationSubmit() {
            this.isButtonLoading = true;
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        ></i>
                        Loading`;
            this.$inertia.post(
                this.inviteClientRoute,
                this.invitationForm,
                {
                    onSuccess: (response) => {
                        this.$toastr.s("Invitation Sent Successfully");
                        this.showModal = true;
                        this.isButtonLoading = false;
                        this.submitButtonText = 'Submit'
                        this.invitationForm = {
                            invitation_email: null,
                            invitation_phone: null,
                        };
                    },
                    onError: (errors) => {
                        this.isButtonLoading = false;
                        this.submitButtonText = 'Submit'
                        if (errors.message) {
                            this.$toastr.e(errors.message);
                        }
                    },
                }
            );
        },

        hideModal() {
            this.customizeReferralLink = false
            this.customizeReferralLinkForm.referral_id = this.customizeReferralLinkForm.old_referral_id
            this.$emit('onCloseInviteModal')
        },

        isCustomizeReferralCode() {
            this.customizeReferralLinkForm.referral_id = this.customizeReferralLinkForm.old_referral_id
            this.customizeReferralLink = !this.customizeReferralLink
        },
    },

    computed: {
        referralLink() {
            this.customizeReferralLinkForm.referral_id = this.actualReferralId
            this.customizeReferralLinkForm.old_referral_id = this.actualReferralId

            return route("user-registration-referral", [this.actualReferralId]);
        },

        intakeFormLink() {
            if(this.intakeLinkDetails[0]) {
                return route("user-registration-intake", [this.intakeLinkDetails[0].link])
            }
            return null
        },

        referralLinkWithoutId() {
            return this.referralLink.substring(
                0,
                this.referralLink.lastIndexOf("/")
            );
        },
        
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
    },

    watch: {
        referralDetails(newVal) {
            this.actualReferralId =
                newVal[0].custom_link == null
                    ? newVal[0].link
                    : newVal[0].custom_link;
        
        },
    },

};
</script>

<template>
    <FormModal
        :isShow="showModal"
        :title="inviteModalTitle"
        :isButtonLoading="isButtonLoading"
        :isShowSubmitButton="false"
        :isShowCancelButton="true"
        :clickSubmitButton="handleInvitationSubmit"
        @hideModal="hideModal"
    >
        <div class="row">
            <div v-if="intakeFormLink" class="col-12">
                <div class="mb-3">
                    <label>Intake Form Link</label>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            ref="intake_form_link"
                            v-model="intakeFormLink"
                            readonly
                            v-on:focus="$event.target.select()"
                        />
                        <div class="input-group-text">
                            <Button
                                :onClick="copyIntakeFormURL"
                                type="button" 
                                classes="btn btn-secondary"
                                title="Click to Copy"
                                >
                                <i class="far fa-copy" aria-hidden="true"></i>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div v-if="!customizeReferralLink" class="mb-3">
                    <label>Referral Link</label>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            ref="referral_link"
                            v-model="referralLink"
                            readonly
                            v-on:focus="$event.target.select()"
                        />
                        <div class="input-group-text">
                            <Button
                                :onClick="copyReferralURL"
                                type="button" 
                                classes="btn btn-secondary"
                                title="Click to Copy"
                                >
                                <i class="far fa-copy" aria-hidden="true"></i>
                            </Button>
                            <Button
                                :onClick="isCustomizeReferralCode"
                                type="button" 
                                classes="btn btn-warning margin-top-10 ms-1"
                                title="Click to Customize"
                                >
                                <i
                                    class="fas fa-pencil-alt text-white"
                                    aria-hidden="true"
                                ></i>
                            </Button>
                        </div>
                    </div>
                </div>
                <div v-else class="mb-3">
                    <label>Customize Referral ID:</label>
                    <div class="input-group">
                        <div class="input-group-text">
                            {{ referralLinkWithoutId }}/
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            ref="customReferralId"
                            name="referral_id"
                            v-model="customizeReferralLinkForm.referral_id"
                            @keydown.space.prevent
                            maxlength="50"
                            :class="{
                                'is-invalid':
                                    $page.props.errors.referral_id,
                            }"
                        />
                        <div class="input-group-text">
                            <Button
                                variant="success"
                                :onClick="handleReferralUpdateSubmit"
                                type="submit" 
                                classes=""
                                title="Click to Update"
                                :disabled="isUpdateReferralCodeLoading"
                                v-if="!isUpdateReferralCodeLoading"
                            >
                                <i
                                    class="fas fa-arrow-right"
                                    aria-hidden="true"
                                ></i>
                            </Button>
                            <Button
                                variant="success"
                                type="button"
                                :disabled="isUpdateReferralCodeLoading"
                                v-else
                            >
                                
                                <i
                                    class="bx bx-loader bx-spin font-size-16 align-middle"
                                ></i>
                            </Button>
                            <Button
                                classes="btn btn-warning margin-top-10 ms-1"
                                type="button"
                                :onClick="isCustomizeReferralCode"
                                :disabled="isUpdateReferralCodeLoading"
                                title="Cancel Customization"
                            >
                                <i
                                    class="far fa-window-close"
                                    aria-hidden="true"
                                ></i>
                            </Button>
                        </div>
                        <small
                            class="text-center"
                            style="display: inline-block"
                            >50 Characters maximum, and only
                            Alphanumeric characters, dash(-) and
                            underscore (_) are allowed.
                        </small>
                        <div
                            v-if="$page.props.errors.referral_id"
                            class="invalid-feedback"
                        >
                            {{ $page.props.errors.referral_id }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <label style="display: block">
                        Invite by E-Mail or Phone
                    </label>
                </div>
                <div class="mb-3">
                    <FormInput title="Email" v-model='invitationForm.invitation_email' :required="false" :error="$page.props.errors.invitation_email" type="email" name="invitation_email" />
                </div>
                <div class="mb-3">
                    <FormPhoneInput title="Phone" v-model='invitationForm.invitation_phone' :required="false" :error="$page.props.errors.invitation_phone" type="text" name="phone" @phoneFormatted="invitationForm.invitation_phone = $event" />
                </div>
                <div class="mb-3">
                    <Button 
                        variant="success"
                        :onClick="handleInvitationSubmit"
                        type="submit" 
                        classes="ms-1" 
                        :disabled="isButtonLoading"
                        v-html="submitButtonText"
                        >
                    </Button>
                </div>
            </div>
        </div>
    </FormModal>
</template>